import Generator from '../generator';
import { api } from 'utils/api-client';

const config = {
  entities: {
    api: {
      fetchItem: (type, { websiteId, ...args }, id) =>
        api.get(`/websites/${websiteId}/domains/${id}`, args),
      updateItem: (type, { websiteId, ...args }, id) =>
        api.patch(`/websites/${websiteId}/domains/${id}`, args),
      fetchList: (type, { websiteId, ...args }) =>
        api.get(`/websites/${websiteId}/domains`, args),
      createItem: (type, { websiteId, ...args }) =>
        api.post(`/websites/${websiteId}/domains`, args)
    }
  }
};

export default new Generator('domains', config).createEntityModel();
